import React, { useState, useEffect } from 'react';
import { Row, Col, Card, FormGroup, FormControl, Form } from 'react-bootstrap';
import { Stepper, Step, StepLabel, StepContent, Paper, Typography, Button } from '@material-ui/core';

//conditionanlly rendered from content 
import SelectDate from './selectDate'
import Info from './info'
import Attendees from './addAttendees'
import Cases from './addCases'
import Success from './success'


import moment from "moment";


function getSteps() {
  return ['Conference Info', 'Select Date', 'Add Attendees', 'Add Cases'];
}

const initial = {
  label: '',
  description: '',
  date: '',
  time: '',
  cases: [],
  attendees: [],
};

const New = (props) => {

  const [state, setState] = React.useState(initial);
  const [newItem, setNewItem] = useState(initial)
  const [activeStep, setActiveStep] = React.useState(0);

  const { patientssearch, onAdd, employeeSearch } = props;


  useEffect(() => {
  }, [state])

  const handleChangeInput = name => ({ target: { value } }) => {
    setNewItem({ ...newItem, [name]: value })
    console.log(newItem);
  }

  const steps = getSteps();

  const handleNext = (e) => {
    e.preventDefault();
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSubmit = (state) => {
    if (!state.date) {
      let defaultdate = new Date();
      let defaultdateFormatted = moment(defaultdate).format("YYYY-MM-DD")
      state.date = defaultdateFormatted;
    }
    if (!state.time) {
      let defaultTime = '09:00:00.000';
      state.time = defaultTime;
    }
    // console.log(state)
    onAdd(state)
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  function getStepContent(step) {
    switch (step) {
      case 0:
        return <Info state={state} setState={setState} />;
      case 1:
        return <SelectDate state={state} setState={setState} />;
      case 2:
        return <Attendees employeeSearch={employeeSearch} state={state} setState={setState} />;
      case 3:
        return <Cases patientssearch={patientssearch} state={state} setState={setState} />;
      default:
        return <Success />;
    }
  }

  return (
    <Row className="new-container">
      <Col lg={5} className="progressRow">
        <Stepper activeStep={activeStep} orientation="vertical">
          {steps.map((label, index) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <div className="ButtonRow">
          <Button
            disabled={activeStep === 0}
            onClick={handleBack}
          >
            Back
          </Button>

          <Button
            variant="contained"
            color="primary"
            onClick={activeStep === steps.length - 1 ? () => handleSubmit(state) : handleNext}
            disabled={activeStep === steps.length}
          >
            {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
          </Button>
        </div>
      </Col>

      <Col lg={7}>
        <Typography component={'span'}>{getStepContent(activeStep)}</Typography>
      </Col>
    </Row>
  )
};


export default New;